'use strict';

exports.__esModule = true;

var _logger = require('@wix/web-bi-logger/dist/src/logger');

var defaultLoggerFactory = _interopRequireWildcard(_logger);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Reporter = function () {
  function Reporter() {
    var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        biLoggerFactory = _ref.biLoggerFactory,
        baseUrl = _ref.baseUrl,
        endpoint = _ref.endpoint,
        preset = _ref.preset;

    _classCallCheck(this, Reporter);

    this.preset = preset;
    this.factory = biLoggerFactory ? biLoggerFactory : defaultLoggerFactory.factory({ host: baseUrl });

    this.persistentPublisher = this.factory.logger({
      endpoint: this.preset.persistentEndpoint
    });
    this.nonPersistentPublisher = this.factory.logger({
      endpoint: endpoint || this.preset.nonPersistentEndpoint
    });
  }

  Reporter.prototype.report = function report(data, reporterEndpoint) {
    if (!data) {
      return null;
    }

    switch (reporterEndpoint) {
      case this.preset.persistentEndpoint:
        return this.persistentPublisher.log(data);
      default:
        return this.nonPersistentPublisher.log(data);
    }
  };

  return Reporter;
}();

exports.default = Reporter;